// extracted by mini-css-extract-plugin
export default {"notification":"TWNbOGi1G9MoyL+EYLvlRg=="};